import React from 'react';

/**
 * Simple accessible toggle switch (controlled).
 *
 * Wave 1u7d — Standardised sizing: 44 × 24 px track + 20 × 20 px knob with
 * 2 px breathing room on every side so the knob's `box-shadow` never spills
 * over the track edge (previous 40 × 24 + 16 px translation caused visible
 * overflow on the right when activated).
 */
export default function Toggle({ checked, onChange, label, description, testId, disabled }) {
  return (
    <label className={`flex items-start gap-3 cursor-pointer select-none ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}>
      <span
        className={`relative inline-block w-11 h-6 rounded-full transition-colors shrink-0 mt-0.5 ${checked ? 'bg-[#4F46E5]' : 'bg-[#D4D5E0]'}`}
      >
        <input
          type="checkbox"
          data-testid={testId}
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <span
          className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-sm transition-transform ${checked ? 'translate-x-[22px]' : 'translate-x-0.5'}`}
        />
      </span>
      {(label || description) && (
        <span className="flex-1 min-w-0">
          {label && <span className="block text-[12.5px] font-semibold text-[#1A1B2E]">{label}</span>}
          {description && <span className="block text-[11.5px] text-[#8E8FA5] mt-0.5">{description}</span>}
        </span>
      )}
    </label>
  );
}

